import { useQuery } from "@tanstack/react-query";
import { getToken } from "../utils/token";
import axios from "axios";

export function useGetSwatch(uniqueCode) {
  return useQuery({
    queryKey: ["swatch", uniqueCode],
    queryFn: async () => {
      const token = getToken();
      const response = await axios.get(
        `https://amal.platform.simplifii.com/api/v1/cards?type=Swatch&doesnotmatchwithany___state=Temp,Deleted,Claimed,Free,On%20Frame&cdnullorzero___per_day_rent=1&unique_codes=${uniqueCode}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );
      return response?.data?.response;
    },
  });
}
